








import Vue from "vue";
export default Vue.extend({
    props:{
        annonce:{
            type: String,
            default : ""
        }
    }
});
